import { render, staticRenderFns } from "./DealerAndAgentWizard.vue?vue&type=template&id=28095a88&scoped=true&"
import script from "./DealerAndAgentWizard.vue?vue&type=script&lang=js&"
export * from "./DealerAndAgentWizard.vue?vue&type=script&lang=js&"
import style0 from "./DealerAndAgentWizard.vue?vue&type=style&index=0&id=28095a88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28095a88",
  null
  
)

export default component.exports